module.exports = __webpack_public_path__ + "ae61a3abba082806fa36ad1934cb9202.svg";